<template >
  <div class="updatePwdDialog">
    <el-dialog :title="title" :visible.sync="updatePwdDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="updatePwdForm" :model="updatePwdForm"  label-width="100px" :rules="rules">
        <el-form-item label="原密码"  class="is-required" prop="oldPassword" >
          <el-input v-model.trim="updatePwdForm.oldPassword" placeholder="请输入原密码..."> </el-input>
        </el-form-item>
        <el-form-item label="密码"  class="is-required"  prop="newPassword">
          <el-input v-model.trim="updatePwdForm.newPassword" placeholder="请输入密码..."> </el-input>
        </el-form-item>
        <el-form-item label="确认密码"  class="is-required"  prop="cfrmnewPassword">
          <el-input v-model.trim="updatePwdForm.cfrmnewPassword" placeholder="请输入确认密码..."> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwdDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="save()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">
import commonService from '@/service/commonService'
export default {
  name: 'updatePwdDialog',

  props: {
    id: {
      type: Number
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.updatePwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      title: '修改密码',
      loading: false,
      updatePwdForm: {
        oldPassword: '',
        newPassword: ''
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: '原密码',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 18,
            message: '密码长度在 6 到 18 个字符',
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            min: 6,
            max: 18,
            message: '密码长度在 6 到 18 个字符',
            trigger: 'blur'
          }
        ],
        cfrmnewPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      this.$refs.updatePwdForm.validate(async valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          try {
            let params = {
              oldPassword: '',
              newPassword: ''
            }
            params.newPassword = this.updatePwdForm.newPassword
            params.oldPassword = this.updatePwdForm.oldPassword
            await commonService.updatePwd(params)
            this.$refs.updatePwdForm.resetFields()
            this.$emit('success')
            this.loading = false
            this.updatePwdDialogVisible = false
            this.$alert('密码修改成功，请重新登录', '', {type: 'success'}).then(() => {
              this.$router.push({name: 'login'})
            })
          } catch (e) {
            this.loading = false
            this.$message.error(e && e.msg)
          }
        }
      })
      this.loading = false
    }
  },
  watch: {
    updatePwdDialogVisible (newVal, oldVal) {
      this.title = '修改密码'
      if (newVal && this.$refs.updatePwdForm) {
        this.updatePwdForm = {
          oldPassword: '',
          newPassword: ''
        }
        this.$refs.updatePwdForm.resetFields()
      }
    }
  },
  computed: {
    updatePwdDialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>
</style>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/pages/layout/admin-layout/update-pwd/index.vue